<ng-container *transloco="let t;">
    <form [formGroup]="recipientRoleForm" (ngSubmit)="resendEmail()">
        <div class="modal-header">
            <h4 class="modal-title" id="myModalLabel1">Resend Email</h4>
            <button type="button" class="close" (click)="closeModal()" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body" tabindex="0" ngbAutofocus>
            <div class="px-2 py-1">
                <div class="form-group">
                    <label class="form-label" for="email">{{t("Email (general) - Email")}}</label>
                    <input type="email" formControlName="email" class="form-control" [ngClass]="{ 'is-invalid': submitted && form.email.errors }" aria-describedby="email" />
                    <div *ngIf="submitted && form.email.errors" class="invalid-feedback">
                        <div *ngIf="form.email.errors.required">{{t("Email is required (general) - Email is required")}}</div>
                        <div *ngIf="form.email.errors.email">{{t("Email must be a valid email address (general) - Email must be a valid email address")}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" (click)="closeModal()" rippleEffect>
                {{ t('Cancel button title (cancel button) - Cancel') }}
            </button>
            <button type="submit" class="btn btn-primary" rippleEffect>
                <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
                {{ t('Update and Resend Email Button (Resend email modal - document preview) - Resend invitation email') }}
            </button>
        </div>
    </form>
</ng-container>